<!--
  Nuovo driver — creazione.

  Stesso linguaggio di `DriverPage` e `DriverDetailsPage`: due colonne, card
  con intestazione, riepilogo sticky a destra con la lista di ciò che manca
  prima di poter salvare.

  ⚠️ Trappole note:
   - `is_alive` è INVERTITO per i driver: 0 = operativo. Si crea a 0.
   - `is_jolly` NON si sceglie qui: è una decisione del dispatcher per singola
     corsa, non un attributo anagrafico. Resta nel payload a false.
   - il driver nasce con un `default_point` vuoto creato a parte: il backend
     lo pretende, e senza la creazione fallisce.

  ZONE OPERATIVE — albero Regione → Provincia dal seed ISTAT, salvato con
  `PATCH /driver/:id/provinces` (che SOSTITUISCE l'insieme). Il planner cerca
  i driver per provincia della sede.
-->
<template>
  <div class="adr">
    <!-- ---------- intestazione ---------- -->
    <div class="adr__head">
      <button
        type="button"
        class="adr__back"
        @click="goBack"
      >
        ‹
      </button>
      <div>
        <h1 class="adr__title">
          Nuovo driver
        </h1>
        <p class="adr__sub">
          Anagrafica, agenzia di appartenenza e province in cui opera.
        </p>
      </div>
    </div>

    <el-form
      ref="formRef"
      :model="form"
      :rules="rules"
    >
      <div class="adr__grid">
        <!-- ================= COLONNA PRINCIPALE ================= -->
        <div class="adr__col">
          <!-- ---------- 1. anagrafica ---------- -->
          <section class="adr__card">
            <header class="adr__cardHead">
              <span class="adr__step">1</span>
              <h3>Dati driver</h3>
            </header>
            <div class="adr__cardBody">
              <div class="adr__fields">
                <el-form-item
                  label="Nome"
                  prop="name"
                  class="adr__f"
                >
                  <el-input
                    v-model="form.name"
                    placeholder="Nome"
                  />
                </el-form-item>
                <el-form-item
                  label="Cognome"
                  prop="surname"
                  class="adr__f"
                >
                  <el-input
                    v-model="form.surname"
                    placeholder="Cognome"
                  />
                </el-form-item>
                <el-form-item
                  label="Mail"
                  prop="mail"
                  class="adr__f"
                >
                  <el-input
                    v-model="form.mail"
                    placeholder="nome@esempio.it"
                  />
                </el-form-item>
                <el-form-item
                  label="Data di nascita"
                  prop="date_birth"
                  class="adr__f"
                >
                  <el-date-picker
                    v-model="form.date_birth"
                    type="date"
                    format="DD/MM/YYYY"
                    value-format="YYYY-MM-DD"
                    placeholder="gg/mm/aaaa"
                    style="width: 100%"
                  />
                </el-form-item>
                <el-form-item
                  label="Telefono"
                  prop="telephone_number"
                  class="adr__f"
                >
                  <el-input
                    v-model="form.telephone_number"
                    placeholder="Numero di telefono"
                  />
                </el-form-item>
                <el-form-item
                  label="Telefono emergenza"
                  prop="emergency_telephone_number"
                  class="adr__f"
                >
                  <el-input
                    v-model="form.emergency_telephone_number"
                    placeholder="Contatto in caso di emergenza"
                  />
                </el-form-item>
              </div>
            </div>
          </section>

          <!-- ---------- 2. dati amministrativi ---------- -->
          <section class="adr__card">
            <header class="adr__cardHead">
              <span class="adr__step">2</span>
              <h3>Dati amministrativi</h3>
            </header>
            <div class="adr__cardBody">
              <div class="adr__fields">
                <el-form-item
                  label="Codice fiscale"
                  prop="CF"
                  class="adr__f"
                >
                  <el-input
                    v-model="form.CF"
                    placeholder="Codice fiscale"
                  />
                </el-form-item>
                <el-form-item
                  label="IBAN"
                  prop="iban"
                  class="adr__f"
                >
                  <el-input
                    v-model="form.iban"
                    placeholder="IBAN per i compensi"
                  />
                </el-form-item>
              </div>
            </div>
          </section>

          <!-- ---------- 3. agenzia e zone ---------- -->
          <section class="adr__card">
            <header class="adr__cardHead">
              <span class="adr__step">3</span>
              <h3>Agenzia e zone</h3>
            </header>
            <div class="adr__cardBody">
              <div class="adr__fields">
                <el-form-item
                  label="Agenzia"
                  prop="agencyId"
                  class="adr__f"
                >
                  <el-select
                    v-model="form.agencyId"
                    filterable
                    clearable
                    placeholder="Scegli l'agenzia"
                    :loading="agenciesLoading"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="a in agencies"
                      :key="a.id"
                      :label="a.company_name"
                      :value="a.id"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="Cambio preferito"
                  class="adr__f"
                >
                  <el-select
                    v-model="form.transmission"
                    clearable
                    placeholder="Indifferente"
                    style="width: 100%"
                  >
                    <el-option
                      label="Manuale"
                      value="manual"
                    />
                    <el-option
                      label="Automatico"
                      value="automatic"
                    />
                    <el-option
                      label="Entrambi"
                      value="both"
                    />
                  </el-select>
                </el-form-item>
              </div>

            </div>
          </section>

          <!-- ---------- 4. zone operative (province M3) ---------- -->
          <section class="adr__card">
            <header class="adr__cardHead">
              <span class="adr__step">4</span>
              <h3>Zone operative</h3>
              <span
                v-if="provinceIds.length"
                class="adr__count"
              >{{ provinceIds.length }}
                {{ provinceIds.length === 1 ? 'provincia' : 'province' }}</span>
            </header>
            <div class="adr__cardBody">
              <p class="adr__hint">
                Le province in cui il driver opera. Sono l'elenco ufficiale
                ISTAT, lo stesso della scheda driver.
              </p>

              <div
                v-if="regionsLoading"
                class="adr__regionsLoading"
              >
                Caricamento province…
              </div>

              <div
                v-for="r in regions"
                :key="r.id"
                class="adr__regionBlock"
              >
                <div class="adr__regionHead">
                  <span class="adr__regionName">{{ r.name }}</span>
                  <el-button
                    text
                    size="small"
                    @click="toggleRegion(r)"
                  >
                    {{ allSelected(r) ? 'Deseleziona tutte' : 'Seleziona tutte' }}
                  </el-button>
                </div>
                <el-checkbox-group v-model="provinceIds">
                  <el-checkbox
                    v-for="p in r.provinces"
                    :key="p.id"
                    :label="p.id"
                    class="adr__check2"
                  >
                    {{ p.name }} ({{ p.sigla }})
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </section>
        </div>

        <!-- ================= RIEPILOGO ================= -->
        <aside class="adr__aside">
          <section class="adr__card adr__card--sticky">
            <header class="adr__cardHead">
              <h3>Riepilogo</h3>
            </header>
            <div class="adr__cardBody">
              <div class="adr__sum">
                <span class="adr__sumK">Driver</span>
                <span class="adr__sumV">{{ fullName || '—' }}</span>
              </div>
              <div class="adr__sum">
                <span class="adr__sumK">Agenzia</span>
                <span class="adr__sumV">{{ agencyName || '—' }}</span>
              </div>
              <div class="adr__sum">
                <span class="adr__sumK">Zone</span>
                <span class="adr__sumV">{{ provinceIds.length || '—' }}</span>
              </div>

              <div class="adr__checklist">
                <p class="adr__checkTitle">
                  Prima di creare
                </p>
                <p
                  v-for="c in checklist"
                  :key="c.label"
                  class="adr__check"
                  :class="{ 'is-ok': c.ok }"
                >
                  <span class="adr__checkIco">{{ c.ok ? '✓' : '○' }}</span>
                  {{ c.label }}
                </p>
              </div>

              <el-button
                type="primary"
                class="adr__submit"
                :loading="saving"
                @click="onSubmit"
              >
                Crea driver
              </el-button>
              <el-button
                class="adr__cancel"
                @click="goBack"
              >
                Annulla
              </el-button>

              <p class="adr__note">
                Il driver nasce <b>operativo</b>. Il ruolo jolly non è
                un'anagrafica: si decide corsa per corsa dal dispatcher.
              </p>
            </div>
          </section>
        </aside>
      </div>
    </el-form>
  </div>
</template>

<script>
import { ref, reactive, computed } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import driverAPI from '../../services/driverAPI.js';
import agencyAPI from '../../services/agencyAPI';
import pointAPI from '../../services/pointAPI';

export default {
  name: 'AddDriverPage',

  setup() {
    const router = useRouter();
    const formRef = ref(null);
    const saving = ref(false);

    const agencies = ref([]);
    const agenciesLoading = ref(false);

    // ------------------------------------------------------------------
    //  ZONE OPERATIVE — province dal seed ISTAT, scelte sull'albero
    //  Regione → Provincia. Il salvataggio passa da `PATCH /driver/:id/provinces`,
    //  che SOSTITUISCE l'insieme — quindi si manda lo stato finale.
    //
    //  Ne consegue un salvataggio in DUE PASSI: le province non stanno nel
    //  payload di creazione, si assegnano al driver appena creato. Il caso
    //  in cui il primo passo riesce e il secondo no va detto, non nascosto:
    //  il driver esisterebbe senza zone.
    // ------------------------------------------------------------------
    const regions = ref([]);
    const regionsLoading = ref(false);
    const provinceIds = ref([]);

    const form = reactive({
      name: '',
      surname: '',
      mail: '',
      telephone_number: '',
      emergency_telephone_number: '',
      date_birth: '',
      iban: '',
      CF: '',
      transmission: '',
      agencyId: '',
    });

    const rules = {
      mail: [
        { required: true, message: 'Inserire la mail', trigger: 'blur' },
        { type: 'email', message: 'Mail non valida', trigger: 'blur' },
      ],
      telephone_number: [
        { required: true, message: 'Inserire il numero di telefono', trigger: 'blur' },
      ],
      CF: [
        { required: true, message: 'Inserire il codice fiscale', trigger: 'blur' },
        { min: 11, max: 16, message: 'Numero di caratteri errato', trigger: 'blur' },
      ],
      agencyId: [
        { required: true, message: "Selezionare un'agenzia", trigger: 'change' },
      ],
    };

    const fullName = computed(() =>
      [form.name, form.surname].filter(Boolean).join(' ')
    );
    const agencyName = computed(
      () => agencies.value.find((a) => a.id === form.agencyId)?.company_name || ''
    );

    const checklist = computed(() => [
      { label: 'Mail', ok: !!form.mail },
      { label: 'Telefono', ok: !!form.telephone_number },
      { label: 'Codice fiscale', ok: form.CF.length >= 11 },
      { label: 'Agenzia', ok: !!form.agencyId },
      { label: 'Almeno una provincia', ok: provinceIds.value.length > 0 },
    ]);

    // Selezione per regione: stesse funzioni della scheda driver.
    const allSelected = (region) =>
      (region.provinces || []).length > 0 &&
      region.provinces.every((p) => provinceIds.value.includes(p.id));

    const toggleRegion = (region) => {
      const ids = (region.provinces || []).map((p) => p.id);
      provinceIds.value = allSelected(region)
        ? provinceIds.value.filter((id) => !ids.includes(id))
        : [...new Set([...provinceIds.value, ...ids])];
    };

    const loadRegions = async () => {
      regionsLoading.value = true;
      try {
        regions.value = await driverAPI.getRegionsTree();
      } catch (e) {
        console.error('Elenco regioni non disponibile:', e);
        ElMessage({ message: 'Impossibile caricare le province', type: 'error' });
      } finally {
        regionsLoading.value = false;
      }
    };
    loadRegions();

    const loadAgencies = async () => {
      agenciesLoading.value = true;
      try {
        const r = await agencyAPI.getAgencies();
        agencies.value = r.data?.data ?? r.data ?? [];
      } catch (e) {
        console.error('Agenzie non caricate:', e);
        ElMessage({ message: 'Elenco agenzie non disponibile', type: 'error' });
      } finally {
        agenciesLoading.value = false;
      }
    };
    loadAgencies();

    const goBack = () => router.push('/driver');

    const onSubmit = () => {
      formRef.value.validate(async (valid) => {
        if (!valid) return;
        if (!provinceIds.value.length) {
          ElMessage({
            message: 'Scegli almeno una provincia in cui il driver opera.',
            type: 'error',
          });
          return;
        }

        saving.value = true;
        try {
          // Il backend pretende un punto di default. Si crea vuoto, come nella
          // versione precedente: senza, la creazione del driver fallisce.
          const point = await pointAPI.postPoint({
            address: '', street_number: '', cap: '', city: '', province: '', label: '',
          });

          const payload = {
            name: form.name,
            surname: form.surname,
            mail: form.mail,
            telephone_number: form.telephone_number,
            emergency_telephone_number: form.emergency_telephone_number,
            date_birth: form.date_birth,
            iban: form.iban,
            CF: form.CF,
            transmission: form.transmission,
            role: 'driver',
            // ⚠️ INVERTITO: 0 = driver operativo. Non è un refuso.
            is_alive: 0,
            // deciso dal dispatcher per corsa, non qui
            is_jolly: false,
            agency: { id: form.agencyId },
            // Le zone NON stanno qui: le province si assegnano subito dopo, con la
            // rotta dedicata.
            areas: [],
            default_point: point.data,
          };

          const resp = await driverAPI.createDriver(payload);
          if (resp?.status !== 201 && resp?.status !== 200) return;

          // ---- secondo passo: le zone ----------------------------------
          // Le province hanno una rotta propria e vanno assegnate al driver
          // appena creato. Se questa fallisce il driver ESISTE GIÀ, ma senza
          // zone: dirlo, e mandare chi salva sulla scheda dove può rimediare.
          // Silenziare l'errore lascerebbe un driver muto per il dispatcher.
          // ⚠️ La creazione passa da `POST /auth/register`, che NON restituisce
          // il driver nudo: lo incapsula in `{ stato, messaggio }`. L'id sta
          // quindi in `data.messaggio.id`. Cercarlo in `data.id` lo trova
          // sempre `undefined`, e le zone non verrebbero mai assegnate.
          const nuovoId = resp.data?.messaggio?.id ?? resp.data?.id;
          try {
            if (!nuovoId) throw new Error('id del driver non restituito');
            await driverAPI.setDriverProvinces(nuovoId, provinceIds.value);
          } catch (e) {
            console.error('setDriverProvinces:', e?.response?.status, e?.message);
            ElMessage({
              message:
                'Driver creato, ma le zone non sono state salvate: impostale dalla sua scheda.',
              type: 'warning',
              duration: 8000,
            });
            router.push(nuovoId ? `/driver/detail/${nuovoId}` : '/driver');
            return;
          }

          ElMessage({ message: 'Driver creato', type: 'success' });
          router.push('/driver');
        } catch (error) {
          // Il backend risponde con lo status giusto: 409 mail già usata,
          // 400 dati non validi.
          const status = error?.response?.status;
          ElMessage({
            message:
              status === 409
                ? 'Mail già utilizzata da un altro utente'
                : status === 400
                  ? 'Dati non validi: controlla i campi'
                  : 'Creazione del driver non riuscita',
            type: 'error',
          });
          console.error('createDriver:', status, error?.response?.data);
        } finally {
          saving.value = false;
        }
      });
    };

    return {
      formRef, form, rules, saving,
      agencies, agenciesLoading, regions, regionsLoading, provinceIds,
      fullName, agencyName, checklist,
      allSelected, toggleRegion, onSubmit, goBack,
    };
  },
};
</script>

<style scoped>
.adr {
  padding: 4px 0 40px;
}

/* ----- intestazione ----- */
.adr__head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 18px;
}
.adr__back {
  width: 30px;
  height: 30px;
  flex: none;
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
  border-radius: var(--radius-sm);
  font-size: 15px;
  line-height: 1;
  color: var(--text-secondary);
  cursor: pointer;
}
.adr__back:hover {
  color: var(--text-primary);
  border-color: var(--color-neutral-300);
}
.adr__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: var(--text-primary);
}
.adr__sub {
  margin: 3px 0 0;
  font-size: 13px;
  color: var(--text-secondary);
  max-width: 62ch;
}

/* ----- impianto a due colonne ----- */
.adr__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 18px;
  align-items: start;
}
.adr__col {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.adr__card {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}
.adr__card--sticky {
  position: sticky;
  top: 16px;
}
.adr__cardHead {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 18px;
  border-bottom: 1px solid var(--border-light);
}
.adr__cardHead h3 {
  margin: 0;
  font-size: 14.5px;
  font-weight: 650;
  color: var(--text-primary);
}
.adr__step {
  width: 22px;
  height: 22px;
  flex: none;
  border-radius: var(--radius-full);
  background: var(--brand-navy);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11.5px;
  font-weight: 700;
}
.adr__cardBody {
  padding: 16px 18px 6px;
}

/* ----- campi ----- */
.adr__fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 16px;
}
.adr__f {
  min-width: 0;
}
:deep(.adr__f .el-form-item__label) {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary);
  line-height: 1.6;
  padding-bottom: 2px;
}

/* ----- zone operative: albero regione → province ----- */
.adr__hint {
  margin: 0 0 14px;
  font-size: 12px;
  line-height: 1.45;
  color: var(--text-tertiary);
}
.adr__count {
  margin-left: auto;
  font-size: 11px;
  font-weight: 650;
  color: var(--brand-violet);
  background: var(--svc-fleet-bg, #e7e3fe);
  border-radius: var(--radius-full);
  padding: 2px 9px;
}
.adr__regionsLoading {
  padding: 10px 0 16px;
  font-size: 12.5px;
  color: var(--text-tertiary);
}
.adr__regionBlock {
  padding: 10px 0;
  border-top: 1px solid var(--border-light);
}
.adr__regionBlock:first-of-type {
  border-top: 0;
}
.adr__regionHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
}
.adr__regionName {
  font-size: 12.5px;
  font-weight: 650;
  color: var(--text-primary);
}
/* Le province sono tante: griglia fluida invece di una colonna lunghissima. */
:deep(.adr__regionBlock .el-checkbox-group) {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 2px 12px;
}
:deep(.adr__check2) {
  margin-right: 0;
  height: 26px;
  font-weight: 400;
}

/* ----- riepilogo ----- */
.adr__aside {
  min-width: 0;
}
.adr__sum {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 0;
  border-bottom: 1px solid var(--border-light);
}
.adr__sumK {
  font-size: 12px;
  color: var(--text-secondary);
}
.adr__sumV {
  font-size: 13px;
  font-weight: 650;
  color: var(--text-primary);
  text-align: right;
  overflow-wrap: anywhere;
}

.adr__checklist {
  margin: 14px 0 4px;
}
.adr__checkTitle {
  margin: 0 0 7px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary);
}
.adr__check {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 5px;
  font-size: 12.5px;
  color: var(--text-tertiary);
}
.adr__check.is-ok {
  color: var(--text-primary);
}
.adr__checkIco {
  width: 14px;
  text-align: center;
  color: var(--text-tertiary);
}
.adr__check.is-ok .adr__checkIco {
  color: var(--color-success);
  font-weight: 700;
}

.adr__submit,
.adr__cancel {
  width: 100%;
  margin: 0 0 8px;
}
.adr__note {
  margin: 6px 0 12px;
  font-size: 11.5px;
  line-height: 1.5;
  color: var(--text-tertiary);
}

/* ----- adattamento ----- */
@media (max-width: 1080px) {
  .adr__grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .adr__card--sticky {
    position: static;
  }
}
@media (max-width: 620px) {
  .adr__fields {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
